module.exports = __webpack_public_path__ + "static/media/pendingMiles.87820e0d.svg";